export const getEmailsList = obj => {
  const emailsArr = [];

  obj.included.forEach(emailItem => {
    if (emailItem.attributes.email) {
      emailsArr.push(emailItem.attributes.email);
    }
  });

  return emailsArr;
};
